import React from 'react';
import SettingsSectionHeader from '../../../../../components/Dashboard/settings/ui/SettingsSectionHeader';
import FileDropBox from '../../../../../components/ui/FileDropBox/FileDropBox';
import { IonicInput } from 'ionic-ui';
import { IonIcon } from '@ionic/react';
import SettingsMainContentWrapper from '../../../../../components/Dashboard/settings/ui/SettingsMainContentWrapper';
import SettingsActionButtons from '../../../../../components/Dashboard/settings/ui/SettingsActionButtons';
import SettingsGridWrapper from '../../../../../components/Dashboard/settings/ui/SettingsGridWrapper';
import { copyOutline, personOutline } from 'ionicons/icons';
import { useClipboard } from '../../../../../hooks/useClipboard';
import PhoneNumberInput from '../../../../../components/ui/PhoneNumberInput';
import useStoreServices from '../../../../../services/stores/hooks/useStoreServices';
import { Controller, FormProvider } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/store';
// LOCATION BANNER — comment out the next import + <LocationUpdateBanner /> to disable
import LocationUpdateBanner from '../../../../../components/ui/LocationUpdateBanner';

export default function StoreProfile() {
  const { methods: mainMethods, handleUpdateStoreProfile } = useStoreServices();
  const address = mainMethods.watch('address');
  const { copy } = useClipboard(address, {
    onSuccessMessage: 'Address copied',
  });
  const activeStore = useSelector(
    (state: RootState) => state.userStores.activeStore
  );

  return (
    <SettingsGridWrapper>
      {/* LOCATION BANNER — comment out to disable once all stores have coordinates */}
      <LocationUpdateBanner geoLocation={activeStore?.geo_location} />

      <FormProvider {...mainMethods}>
        <>
          <div>
            <SettingsSectionHeader
              header="Store Profile"
              subheader="You can change  your personal information settings here."
            />
          </div>

          {/* MAIN FORM */}
          <SettingsMainContentWrapper className="grid gap-4">
            <form className="contents">
              <div className="col-span-2 space-y-4">
                <div className="space-y-1">
                  <label className="medium-emphasis-text mb-1 block text-sm">
                    Upload store logo
                  </label>
                  <Controller
                    control={mainMethods.control}
                    name="store_logo"
                    render={({ field, fieldState }) => (
                      <FileDropBox
                        {...field}
                        allowCropping={true}
                        acceptedTypes={{ 'image/jpeg': ['.jpeg', '.png'] }}
                        maxFiles={1}
                        cropperAspectRatio={1 / 1}
                        errorMessage={fieldState.error?.message}
                      />
                    )}
                  />
                </div>

                <div className="space-y-1">
                  <label className="medium-emphasis-text mb-1 block text-sm">
                    Upload store banner
                  </label>
                  <Controller
                    control={mainMethods.control}
                    name="store_banner"
                    render={({ field, fieldState }) => (
                      <FileDropBox
                        {...field}
                        maxFiles={1}
                        allowCropping={true}
                        cropperAspectRatio={2 / 3}
                        acceptedTypes={{ 'image/jpeg': ['.jpeg', '.png'] }}
                        errorMessage={fieldState.error?.message}
                      />
                    )}
                  />
                </div>
              </div>
              <Controller
                control={mainMethods.control}
                name="name"
                render={({ field, fieldState }) => (
                  <IonicInput
                    {...field}
                    size="xlg"
                    prefix={<IonIcon icon={personOutline} className="size-6" />}
                    placeholder="Enter store name"
                    label="Store name*"
                    containerClass="max-md:col-span-2"
                    hint={fieldState.error?.message}
                    hintClass="text-red-600 dark:text-red-600"
                  />
                )}
              />
              <Controller
                control={mainMethods.control}
                name="address"
                render={({ field, fieldState }) => (
                  <IonicInput
                    size="xlg"
                    {...field}
                    suffix={
                      <button
                        type="button"
                        onClick={() => copy()}
                        className="w-fit px-4 rounded-r-md bg-gray-50 low-emphasis-text h-full border-l border-gray-200"
                      >
                        <span className="max-sm:hidden">Copy</span>
                        <span className="sm:hidden">
                          <IonIcon icon={copyOutline} />
                        </span>
                      </button>
                    }
                    innerContainerClass="pr-0"
                    containerClass="max-md:col-span-2"
                    placeholder="Enter store address"
                    label="Store address"
                    hint={fieldState.error?.message}
                    hintClass="text-red-600 dark:text-red-600"
                  />
                )}
              />

              {/* <Controller
                control={mainMethods.control}
                name='address'
                render={({field}) => (
                )}
              /> */}

              <Controller
                control={mainMethods.control}
                name="contact_email"
                render={({ field, fieldState }) => (
                  <IonicInput
                    {...field}
                    size="xlg"
                    placeholder="Enter store email"
                    label="Store email"
                    containerClass="max-md:col-span-2"
                    hint={fieldState.error?.message}
                    hintClass="text-red-600 dark:text-red-600"
                  />
                )}
              />

              <Controller
                control={mainMethods.control}
                name="contact_phone"
                render={({ field, fieldState }) => (
                  <PhoneNumberInput
                    {...field}
                    label="Store Phone Number"
                    size="xlg"
                    containerClass="max-md:col-span-2"
                    placeholder="e.g. 0801 234 5678"
                    hint={fieldState?.error?.message}
                    hintClass="text-red-600 dark:text-red-600"
                  />
                )}
              />

              <Controller
                control={mainMethods.control}
                name="description"
                render={({ field, fieldState }) => (
                  <IonicInput
                    {...field}
                    size="xlg"
                    label="store Description*"
                    containerClass="col-span-2"
                    className="resize-none"
                    type="textarea"
                    placeholder="e.g. Briefly describe what your store offers and what makes it unique"
                    hint={fieldState.error?.message}
                    hintClass="text-red-600 dark:text-red-600"
                  />
                )}
              />
              {/* <div className="col-span-2">
                <label
                  htmlFor="store-status"
                  className="high-emphasis-text text-sm"
                >
                  Store Status
                </label>
                <CustomToggle
                  label="Open Store"
                  subLabel="Toggle to temporarily close your store"
                  name="store-status"
                />
              </div>
              <div className="col-span-2">
                <CustomToggle
                  label="Email Notifications"
                  subLabel="Appointment reminders, health tips"
                  name="email-notifications"
                />
              </div> */}
            </form>
          </SettingsMainContentWrapper>
          <SettingsActionButtons
            onSave={handleUpdateStoreProfile}
            onCancel={mainMethods.reset}
            canSave={mainMethods.formState.isDirty}
          />
        </>
      </FormProvider>
    </SettingsGridWrapper>
  );
}
